import { render } from "./Welcome.vue?vue&type=template&id=6b0ea614&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=6b0ea614&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b0ea614"

export default script